<template>
    <div class="">
        <!-- <CouponItem
            v-for="(campaign) in purchases"
            :key="campaign.id"
            :purchase="campaign"
            @onClickPurchase="clickPurchase(campaign)">
        </CouponItem> -->
        <HistoryItem
                v-for="(campaign) in purchases"
                :key="campaign.id"
                :purchase="campaign"
                @onClickPurchase="clickPurchase(campaign)"
        ></HistoryItem>
    </div>
</template>

<script>
import Util from '@/helper/Utility.js';
//service
import BzbsHistory from '@/core/History/service/BzbsHistory.js';
import { CampaignType } from '@/helper/StaticValue.js';
import { SerialModel } from '@/core/Redeem/model/SerialModel.js';
//mixin
import ModalMixin from '@/mixin/ModalMixin';
//component
//import CouponItem from "@/module/MyCoupon/component/CouponItem.vue";
import HistoryItem from "@/module/History/component/HistoryRedeem/HistoryItem.vue"

export default {
    name: 'Available',
    mixins: [ModalMixin],
    components: {
        ///CouponItem,
        HistoryItem
    },
    props: {
        listConfig:   { type: Object, required: true },
        filterConfig: { type: Object, required: true },
    },
    data: function() {
        return {
            purchases: [],
            isLoading: false,
            isLoaded: false,
            isHaveItem: false,

            isSerialLoading: false,
        };
    },
    created: function() {
    },
    methods: {
        getList: function () {
            return new Promise((resolve) => {
                this.isLoading = true;
                BzbsHistory.apiGetPurchase(this.listConfig, this.filterConfig).subscribe((purchases) => {
                    Util.log('history list', purchases);

                    this.listConfig.increstSkip();
                    //check is there are more campaign.
                    if (purchases && purchases.length < this.listConfig.defaultTopAmount) {
                        this.listConfig.setSeeMoreEnable(false);
                    }
                    //reinitialize list if no skip.
                    if (this.listConfig.intSkip == this.listConfig.defaultTopAmount) {
                        this.purchases = [];
                    }

                    for (var purchase of purchases) {
                        //TODO: Add GA Tracking.
                        this.purchases.push(purchase);
                    }

                    this.isLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = this.purchases.length > 0 ? true : false;
                    resolve();
                }, (err) => {
                    resolve();
                    this.isLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    this.errorApi(err);
                });
            });
        },
        loadMore: function() {
            if (!this.listConfig.isSeeMoreEnable) {
                return;
            }

            if (this.isLoading) {
                return;
            }
            this.getList();
        },
        //#region action history
        clickPurchase: function (purchase) {
            //check internet stuff.
            if (this.isSerialLoading) {
                return;
            }

            // this.clickedIndex = index;
            if (purchase.type === CampaignType.Interface) {
                this.openInterfaceHistory(purchase);
                return;
            }

            this.isSerialLoading = true;
            BzbsHistory.apiRedeemDetail(purchase.redeemKey).subscribe({
                next: (result) => {
                    this.isSerialLoading = false;
                    purchase.updateAfterRedeem(result);

                    if (this.isShowSerialModal(purchase)) {
                        this.openSerial(purchase);
                    }
                    // TODO ถ้ามีไรแปลกๆ ก็เปิด comment นี้ได้ (Chat)
                    // else {
                    //     this.refreshList();
                    // }
                },
                error: (err) => {
                    this.isSerialLoading = false;
                    console.log(err);
                },
            });
        },

        openSerial: function(purchase) {
            let serialModel = new SerialModel();
            serialModel.setModelFromDataModel(purchase);

            console.log('open serial');
            this.modal.serialModal
                    .clearModal()
                    .setSerial(serialModel)
                    .show();
            this.modal.serialModal.onSerialExpire(() => {
                purchase.setPurchaseExpired();
                this.refreshList();
            });
        },
        isShowSerialModal: function (purchase) {
            if (purchase.serial === 'XXXXXXX') {
                return false;
            }
            if (purchase.expireIn && purchase.expireIn <= 0) {
                return false;
            }

            if (purchase.type === CampaignType.Interface) {
                if (purchase.pointType === "get")
                    return false;

                return true;
            }

            if (purchase.type === CampaignType.Free ||
                purchase.type === CampaignType.Deal ||
                purchase.type === CampaignType.Buy) {
                if (purchase.delivered) {
                    return false;
                }
            }

            if (purchase.type === CampaignType.Draw) {
                return false;
            }

            return true;
        },

        refreshList: function () {
            var tmp = this.purchases;
            this.purchases = [];

            this.$nextTick().then( () => {
                this.purchases = tmp;
            });
        },
        //#endregion action history
    }
}

</script>

<style>

</style>
